import React from 'react';
import { InputNumberProps } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface CustomInputNumberProps extends InputNumberProps {
	placeholder?: string;
}

export default function InputNumber({ placeholder = '', ...props }: Readonly<CustomInputNumberProps>): JSX.Element {
	return <S.InputNumberWrapper {...props} placeholder={I18n.get(placeholder)} />;
}
